import Link from 'next/link';
import { BiLayer } from 'react-icons/bi';
import { IoSearch } from 'react-icons/io5';
import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import XImage from '@/components/@base/x-image';
import GradientButton from '@/components/app/home/components/hero/@shared/button';
import Section from '@/components/app/product/components/@shared/section';
import Props from '@/components/app/product/components/content/bundle-pack/type';
import RoundedIcon from '@/components/shared/components/icon/rounded';
import IconTextCombo from '@/components/shared/components/icon-text-combo';
import PriceView from '@/components/shared/components/price-view';

import imagesList from '@/constant/images-list';
import { pageLevelLocalization } from '@/constant/localization';
import { DATA_CY_PRODUCT_BUNDLE_CARD } from '@/constant/cypress';

const { product: productLocalization } = pageLevelLocalization;

export default function BundlePack({
  title,
  slug,
  shortDescription,
  bundleItems,
  price,
  lastPrice,
  discount,
}: Props) {
  return (
    <figure>
      <Section
        data-cy={DATA_CY_PRODUCT_BUNDLE_CARD}
        center
        className='hidden grid-cols-5 bg-[#1F2025] md:grid md:p-0'
      >
        <Container center className='col-span-3 flex-col gap-4 p-7'>
          <Link href={`/web/${slug}`} className='w-full' prefetch={false}>
            <IconTextCombo
              Icon={
                <RoundedIcon
                  icon={
                    <XImage
                      src={imagesList.icons.relatedProductIcon}
                      alt={productLocalization.bundlePack}
                      width={22}
                      height={22}
                      className='rounded-full'
                    />
                  }
                />
              }
              title={title}
              textClassName='text-[#F9FAFC] text-lg font-bold flex-1 line-clamp-1'
            />
          </Link>
          <figcaption>
            <Text className='line-clamp-2 text-[#F4F5F6]'>{shortDescription}</Text>
          </figcaption>
          {bundleItems && bundleItems.length > 0 && (
            <Container
              center
              className='gap-3 rounded-lg bg-[#FF96061C] px-[22px] py-4 text-[#FFC87B]'
            >
              <BiLayer className='w-[17px]' />
              <blockquote>
                <Text className='line-clamp-2'>
                  {productLocalization.buyBundlePackOffer(bundleItems?.length - 1)}
                </Text>
              </blockquote>
            </Container>
          )}
          <Container center className='mt-2 w-full justify-between'>
            <PriceView
              isDark
              showDiscountWithoutExpiration
              showDiscountLabel
              discount={discount}
              price={price}
              lastPrice={lastPrice}
              priceClassName='text-[22px] font-bold'
              lastPriceClassName='text-base font-bold'
              className='flex items-center gap-2'
            />
            <GradientButton
              Icon={<IoSearch size={16} />}
              label={productLocalization.view}
              url={`/web/${slug}`}
              className='flex h-[42px] items-center gap-1 rounded-md px-6 text-sm'
              wrapperClassName='mt-0'
            />
          </Container>
        </Container>
        {bundleItems && bundleItems.length > 0 && (
          <Container
            center
            className='col-span-2 h-full border-r-[1px] border-r-[#F1F2F41A] p-10'
          >
            <Container className='grid grid-flow-col grid-rows-2 gap-3'>
              {bundleItems.slice(0, 4).map((item) => (
                <Link
                  prefetch={false}
                  key={item.id}
                  href={`/web/${item.slug}`}
                  className='self-start rounded-md! shadow-[0px_10px_25px_0px_#0000001C] nth-4:-mt-5 nth-last-4:mt-5'
                >
                  <Container
                    center
                    className='h-[106px] w-[106px] rounded-md bg-[#5b5c604d] p-5'
                  >
                    <XImage
                      src={item.icon.publicLink}
                      alt={item.title}
                      width={54}
                      height={54}
                    />
                  </Container>
                </Link>
              ))}
            </Container>
          </Container>
        )}
      </Section>
    </figure>
  );
}
